// features/auth/authSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cartItem: [],
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addItemToCart: (state, action) => {
      state.cartItem.push(action.payload);
    },
    removeItemFromCart: (state, action) => {
      state.cartItem = state.cartItem.filter(
        (item) => item?.id !== action.payload
      );
    },
  },
});

export const { addItemToCart, removeItemFromCart } = cartSlice.actions;
export default cartSlice.reducer;
